import { ActionButtonVariants } from 'components/action-button';

import ThemeBase from './theme-base';

export default {
  ...ThemeBase,
  pickup: {
    ...ThemeBase.pickup,
    icon: 'storeThree',
  },
  catering: {
    ...ThemeBase.catering,
    pickup: {
      ...ThemeBase.catering.pickup,
      icon: 'cateringTwo',
    },
  },
  iconContainer: {
    ...ThemeBase.iconContainer,
  },
  text: {
    ...ThemeBase.text,
  },
  bottomServiceWrapper: {
    ...ThemeBase.bottomServiceWrapper,
  },
  underline: {
    ...ThemeBase.underline,
  },
  inProgressVariant: ActionButtonVariants.INVERSE,
};
